// React&NextJS
import React, { useContext, useEffect } from 'react'
// Context&Auth
import { UIContext } from '../../../context/UIContext'
// 3rd party libraries
import { AnimatePresence, motion } from 'framer-motion'
// Services&Helper functions
import { useKeyDown } from '../../../hooks/useKeyDown'
// Styles
import s from './ShareModal.module.scss'
import classnames from 'classnames'
// Components
import { Container } from '../../core/container/Container'
import { WhiteBox } from '../../core/whiteBox/WhiteBox'
import { Text } from '../../core/text/Text'
import { Memory, ScrapedFunerals } from '../../../types/types'
import { Icon } from '../../core/icon/Icon'
import { Image } from '../../core/image/Image'

const c = classnames.bind(s)

type Props = {
    isOpen: boolean
    closeModal: Function
    title: string
    info?: string
    data?: Memory | ScrapedFunerals
    isLoading?: boolean
    imgURL?: string
    [key: string]: unknown
}

const HOCModal = ({
    isOpen,
    closeModal,
    title,
    info,
    isLoading,
    imgURL,
    children,
}: Props) => {
    const { uiState, setUIState } = useContext(UIContext)

    useEffect(() => {
        if (isOpen) {
            setUIState({ ...uiState, canScroll: false })
        } else {
            setUIState({ ...uiState, canScroll: true })
        }
        return () => {
            setUIState({ ...uiState, canScroll: true })
        }
    }, [isOpen])

    useKeyDown(['Escape'], ({ key }) => {
        if (key === 'Escape' && isOpen) {
            closeModal()
        }
    })

    const checkIfClosing = (e: React.BaseSyntheticEvent) => {
        if (e.target?.parentNode?.id === 'background') {
            closeModal()
        }
    }

    if (isOpen) {
        return (
            <AnimatePresence>
                <motion.div
                    className={c(s.funeralBG)}
                    onMouseDown={(e) => checkIfClosing(e)}
                    id="background"
                    animate={isOpen ? 'visible' : 'hidden'}
                    initial="hidden"
                    exit="hidden"
                    transition={{
                        duration: 0.2,
                        ease: 'easeOut',
                    }}
                    variants={{
                        visible: {
                            opacity: 1,
                        },
                        hidden: {
                            opacity: 0,
                        },
                    }}
                >
                    <Container className={s.container}>
                        <WhiteBox
                            className={c(s.modal_big, isLoading && s.loadModal)}
                        >
                            <div
                                className={s.closeBtn}
                                onClick={() => closeModal()}
                            >
                                <Icon variant="close" />
                            </div>
                            <div className={s.modalInfo}>
                                <div>
                                    <Text variant="h4">{title}</Text>
                                    {info && <Text variant="p">{info}</Text>}
                                    {children}
                                </div>
                                <Image src={imgURL} height={400} alt="" />
                            </div>
                        </WhiteBox>
                    </Container>
                </motion.div>
            </AnimatePresence>
        )
    }
    return null
}

export default HOCModal
